import {
  JITAI_MESSAGE_CREATE_RESET,
  JITAI_MESSAGE_DELETE_RESET,
  JITAI_MESSAGE_LIST_RESET,
  JITAI_MESSAGE_UPDATE_RESET,
} from '../constants/jitaiConstants'

const resetErrorState = (dispatch) => {
  dispatch({ type: JITAI_MESSAGE_CREATE_RESET })
  dispatch({ type: JITAI_MESSAGE_DELETE_RESET })
  dispatch({ type: JITAI_MESSAGE_LIST_RESET })
  dispatch({ type: JITAI_MESSAGE_UPDATE_RESET })
}

export default resetErrorState 